import { Box, Container } from '@mui/material'
import React from 'react'

import WorldBasePage from '../WorldBasePage'
import Disclaimer from './Disclaimer'
import RuleList from './RuleList'
import { auctionRules, dutchAuctionRules, fhrRules, geotokenLockRules, initialSaleRules, startingPriceRules } from './rules'

const ListPage: React.FC = () => (
  <WorldBasePage>
    <Container>
      <Box display="flex" flexDirection="column">
        <Disclaimer />
        <RuleList rules={startingPriceRules} title="Starting Prices" />
        <RuleList rules={auctionRules} title="Auction" />
        <RuleList rules={dutchAuctionRules} title="Dutch Auction" />
        <RuleList rules={initialSaleRules} title="Initial Sale" />
        <RuleList rules={geotokenLockRules} title="Geotoken Lock" />
        <RuleList rules={fhrRules} title="FHR Benefits" />
      </Box>
    </Container>
  </WorldBasePage>
)

export default ListPage
